import Vue from 'vue'
import Snotify, { SnotifyPosition } from 'vue-snotify'

const options = {
    toast: {
        position: SnotifyPosition.rightTop
    }
}

export default Vue.use(Snotify, options)


// WEBPACK FOOTER //
// ./src/snotify.js